import { createStyles, makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import React, { useState } from 'react';
import { useAlerts } from '../../feedback';
import { Loader } from '../common';
import { Button } from '../common/Button';
import { InputSubmit } from '../common/InputSubmit';
import { useInviteManagedUser } from './useInviteManagedUser';

const fieldValidation = (
  inputText = '',
): { error: true; message: string } | { error: false; emails?: string[] } => {
  if (!inputText) {
    return { error: false };
  }
  const emails = sanitizeEmailInput(inputText);
  if (!emails.length) {
    return { error: true, message: 'Please enter one or more emails' };
  }
  for (const email of emails) {
    if (!isValid(email)) {
      return { error: true, message: `"${email}" is not a valid email address` };
    }
  }
  return { error: false, emails };
};

export const InvitationForm = () => {
  const [showInput, setShowInput] = useState(false);
  const { inviteUsers, inviteStatus } = useInviteManagedUser();
  const { showError } = useAlerts();
  const [inputText, setInputText] = useState('');
  const classes = useStyles();
  const buttonDisabled = inviteStatus === 'loading' && Boolean(inputText);
  const buttonText = inviteStatus === 'loading' ? <Loader /> : 'Invite';

  const handleInvite = async () => {
    const validation = fieldValidation(inputText);
    if (validation.error) {
      return showError(validation.message);
    }

    validation.emails?.length && inviteUsers(validation.emails);
  };

  return (
    <div className={classes.wrapper}>
      {!showInput && (
        <Button variant='outlined' startIcon={<AddIcon />} onClick={() => setShowInput(true)}>
          Add New
        </Button>
      )}
      {showInput && (
        <div className={classes.inputWrapper}>
          <InputSubmit
            value={inputText}
            buttonText={buttonText}
            onChange={setInputText}
            onClick={handleInvite}
            buttonDisabled={buttonDisabled}
            inputPlaceholder='abc@mail.com, xyz@mail.com, ...'
          />
        </div>
      )}
    </div>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      marginBottom: 40,
      display: 'inline-flex',
      alignItems: 'center',
    },
    inputWrapper: {
      width: 400,
    },
  }),
);

function sanitizeEmailInput(inputText: string) {
  return inputText
    .split(',')
    .map((emailString) => emailString.trim())
    .filter((email) => email.length);
}

const isValid = (email: string) => emailRegex.test(email);

const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
